/** Width of a sub-nav dropdown panel, before any viewport clamp. */
export const PANEL_WIDTH = 268;

/** Minimum gap kept between a panel and the viewport's right edge. */
export const VIEWPORT_MARGIN = 12;

/**
 * Horizontal nudge, in px, applied to a dropdown panel relative to its
 * trigger's left edge.
 *
 * Panels align left with their trigger (offset 0) until that would push them
 * past the right edge; then they're pulled left only as far as needed.
 *
 * Only consumed at `subnav` and up (see tailwind `screens.subnav`), where the
 * viewport is always wide enough to hold a full panel between both margins —
 * below that a panel is full-bleed and ignores this. So the result never needs
 * a left-edge or width clamp: pulling left to clear the right margin can't
 * push the panel off the near side.
 */
export const panelOffset = ({
  triggerLeft,
  viewportWidth,
}: {
  triggerLeft: number;
  viewportWidth: number;
}): number => Math.min(0, viewportWidth - VIEWPORT_MARGIN - PANEL_WIDTH - triggerLeft);
